import { concatClasses } from "../../../helpers/concatClasses/index.js";
const getNumber = (cmp) => {
  if (cmp.dsf_legend) {
    return cmp.dsf_legend.at(0);
  }
  return cmp.properties.number;
};
const getNumberWrapperClasses = (cmp) => {
  const classes = ["flex", "relative", "justify-center"];
  if (cmp.properties.direction === "horizontal") {
    classes.push("w-full", "items-center");
  }
  return concatClasses(classes);
};
const getNumberClasses = (cmp) => {
  const { direction, size, isFirst, isLast } = cmp.properties;
  const classes = [direction];
  if (isFirst) {
    classes.push("first");
  } else if (isLast) {
    classes.push("last");
  }
  if (cmp.dsf_state === "completed") {
    classes.push("completed");
    classes.push("previous-active");
  } else if (cmp.dsf_state === "active") {
    classes.push("active");
  }
  if (direction === "vertical" && size === "minimal") {
    classes.push("mt-2.5");
  }
  return concatClasses(classes);
};
const getWrapperClasses = (cmp) => {
  const { direction, size, isLast } = cmp.properties;
  const classes = [direction, size];
  if (isLast) {
    classes.push("last");
  }
  if (direction === "vertical") {
    classes.push("flex", "flex-row", "gap-8");
  }
  return concatClasses(classes);
};
const getTitleClasses = (cmp) => {
  const { direction } = cmp.properties;
  const classes = [];
  if (cmp.dsf_state === "active") {
    classes.push("text-primary-300");
  }
  if (cmp.dsf_description) {
    classes.push("dsf-text-xs-semibold");
  } else {
    classes.push("dsf-text-xs");
  }
  if (direction === "horizontal") {
    classes.push("text-center");
  }
  return concatClasses(classes);
};
const getDescriptionClasses = (cmp) => {
  const { direction } = cmp.properties;
  const classes = ["dsf-text-xxs", "text-neutral-600"];
  if (direction === "horizontal") {
    classes.push("text-center");
  }
  return concatClasses(classes);
};
const getContentWrapperClasses = (cmp) => {
  const { isLast, direction } = cmp.properties;
  const classes = ["content"];
  if (isLast) {
    classes.push("last");
  }
  if (direction === "vertical") {
    classes.push("dsf-px-s", "justify-center");
  } else {
    classes.push("dsf-py-s");
  }
  return concatClasses(classes);
};
export {
  getContentWrapperClasses,
  getDescriptionClasses,
  getNumber,
  getNumberClasses,
  getNumberWrapperClasses,
  getTitleClasses,
  getWrapperClasses
};
